import { useEffect, useRef } from 'react';

function useEffectOnUpdate(fn, dependencyArray) {
    const didMountRef = useRef(false);
    useEffect(() => {
        let result;
        if (didMountRef.current) {
            result = fn();
        } else {
            didMountRef.current = true;
        }
        return result;
    }, dependencyArray); // eslint-disable-line react-hooks/exhaustive-deps
}

export default useEffectOnUpdate;
